export const initialState = {
	visible: true,
};

export type VisibilityState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case "VISIBILITY_CHANGE": {
			const visible = action.visibilityState === "visible" ? true : false;
			return { visible };
		}

		default:
			return state;
	}
}
